module.exports = __webpack_public_path__ + "img/4.c9e19149.png";